"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const callableBasedOnCurrentOs = ({ callbacks, executeProcesses, processor, }) => {
    if (processor.root.platformOS === 'ios') {
        executeProcesses(undefined, callbacks.onIos);
    }
    else if (processor.root.platformOS === 'android') {
        executeProcesses(undefined, callbacks.onAndroid);
    }
    else {
        executeProcesses(undefined, callbacks.onWeb);
    }
};
exports.default = callableBasedOnCurrentOs;
